var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.9274 15.4884C14.9274 16.1094 14.6807 16.705 14.2415 17.1442C13.8024 17.5833 13.2068 17.83 12.5858 17.83H7.12211C6.50108 17.83 5.90549 17.5833 5.46636 17.1442C5.02723 16.705 4.78053 16.1094 4.78053 15.4884V6.12211H4V3.78053H7.51237L8.29289 3H11.415L12.1955 3.78053H15.7079V6.12211H14.9274V15.4884ZM5.56105 6.12211V15.4884C5.56105 15.9024 5.72552 16.2995 6.01827 16.5923C6.31103 16.885 6.70809 17.0495 7.12211 17.0495H12.5858C12.9998 17.0495 13.3969 16.885 13.6896 16.5923C13.9824 16.2995 14.1468 15.9024 14.1468 15.4884V6.12211H5.56105ZM14.9274 5.34158V4.56105H11.8053L11.0247 3.78053H8.68316L7.90263 4.56105H4.78053V5.34158H14.9274ZM7.12211 7.68316H7.90263V15.4884H7.12211V7.68316ZM11.8053 7.68316H12.5858V15.4884H11.8053V7.68316Z",
    fill: "#8E929A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/DeleteIcon.b6e6791f0ebfca64520aa83b475c747d.svg";
export { ForwardRef as ReactComponent };